import React from "react";
import { BROWN, PINK_LADY } from "../../../../constants/style/colors";
import EntityLink from "../../../shared/EntityLink";
import * as S from "../../style";

function SupplierCell({ supplier, entityLinkOptions }) {
    return supplier && supplier.id ? (
        <EntityLink
            entity={supplier}
            options={entityLinkOptions}
        />
    ) : (
        <S.StyledBadge
            textColor={BROWN}
            borderColor={BROWN}
            color={PINK_LADY}
        >
            <span>No supplier assigned</span>
        </S.StyledBadge>
    );
}

export default SupplierCell;
